import { IonIcon } from '@ionic/react';
import clsx from 'clsx';
import { arrowForward } from 'ionicons/icons';
import React from 'react';

type Props = {
  icon: string;
  title: string;
  subtitle?: string;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
  disabled?: boolean;
  className?: string;
  size?: 'fit' | 'lg';
};

export default function VerificationMethodSelector({
  icon,
  onClick,
  subtitle,
  title,
  disabled,
  className = '',
  size = 'lg',
}: Props) {
  const wrapperClass = clsx(
    className,
    size == 'lg' ? 'min-h-24' : 'min-h-fit',
    'w-full shadow-md flex justify-between border-2 cursor-pointer rounded',
    disabled || !onClick
      ? 'opacity-50 hover:border-transparent'
      : 'opacity-100 group hover:border-primary'
  );
  const handleClick = ((e) => {
    if (onClick) onClick(e);
  }) as React.MouseEventHandler<HTMLDivElement>;

  return (
    <div onClick={handleClick} className={wrapperClass}>
      <div className="w-16 flex items-center justify-center">
        <IonIcon icon={icon} className={`text-2xl text-primary`} />
      </div>
      <div className="flex flex-col justify-center flex-grow">
        <p className="text-text-dark-high dark:text-text-light-high font-bold">
          {title}
        </p>
        {subtitle && (
          <p className="text-text-dark-medium dark:text-text-light-medium text-sm">
            {subtitle}
          </p>
        )}
      </div>
      <div className="w-16 flex items-center justify-center ">
        <IonIcon
          icon={arrowForward}
          className={`text-primary text-xl invisible group-hover:visible`}
        />
      </div>
    </div>
  );
}
